export class UserLogin {
    constructor() {
        // this.id = 0;
        this.username = "";
        this.isAuthenticated = false;
    }

    // id: number;
    username: string;
    isAuthenticated: boolean;
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/cms/user-login.ts